import { useNavigate, useLocation } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { useTranslation } from '@cravo/i18n'
import { tenantName } from '@/lib/tenant'
import { useAiEnabled } from '@/lib/use-ai-enabled'

export function AiBubble() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { enabled: aiEnabled } = useAiEnabled()

  if (!aiEnabled) return null
  if (location.pathname === '/ai') return null

  return (
    <div className="ai-bubble" onClick={() => navigate('/ai')}>
      <span className="spark">
        <Sparkles size={12} color="white" />
      </span>
      {t('components.aiBubble.label', { appName: tenantName() })}
    </div>
  )
}
